import React from 'react';
import SearchBar2 from '../SearchBar/SearchBar2';
import Select2DropdownList from '../FormElements/Select2DropdownList';
import DataTable2 from '../DataTable2/DataTable2';
import PendingTag from './PendingTag';
import ExpiredTag from './ExpiredTag';
import SuspendedTag from './SuspendedTag';
import PopupWithUseClickOutside from '../Popups/PopupWithUseClickOutside';
import Popup from '../Popups/Popup';
import UsersInviteCard from '../UsersMgmt/UsersInviteCard';
import DataTableDisplayLengthToggle from '../DataTable2/DataTableDisplayLengthToggle';
import Pagination from '../DataTable2/Pagination';
import Cell from '../DataTable2/DataTableComponents/Cell';

export default class UsersIndexCard extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			data: [],
			meta: {},
			isUserInvitePopupVisible: false,
			isUserProfilePopupVisible: false,
			isSuccessCardPopupVisible: false,
			isTimeoutCardPopupVisible: false,
			sortOrder: 'desc',
			sortColumn: 'lastLoginAt',
			tempQuery: '',
			query: '',
			filteredRoles: null,
			filteredAccountStatus: null,
			displayOptions: [
				10,
				25,
				50,
				100
			],
			currentPage: 0,
			pageLength: 25,
			pageNeighbours: 0
		};

		this.onChange = this.onChange.bind(this);
		this.onSearch = this.onSearch.bind(this);
		this.onClearSearch = this.onClearSearch.bind(this);
		this.onClickRouteToUserProfilePage = this.onClickRouteToUserProfilePage.bind(
			this
		);
		this.onChangeSortOrder = this.onChangeSortOrder.bind(this);
		this.onChangePageLength = this.onChangePageLength.bind(this);
		this.onChangeCurrentPage = this.onChangeCurrentPage.bind(this);
		this.onShowUserInvitePopup = this.onShowUserInvitePopup.bind(this);
		this.onHideUserInvitePopup = this.onHideUserInvitePopup.bind(this);
		this.onShowSuccessCardPopup = this.onShowSuccessCardPopup.bind(this);
		this.onHideSuccessCardPopup = this.onHideSuccessCardPopup.bind(this);
		this.onShowTimeoutCardPopup = this.onShowTimeoutCardPopup.bind(this);
		this.onHideTimeoutCardPopup = this.onHideTimeoutCardPopup.bind(this);
		this.getName = this.getName.bind(this);
		// this.getRolesForSelect2 = this.getRolesForSelect2.bind(this);
	}

	render() {
		// console.log('UsersIndexCard - Props', this.props);
		// console.log('UsersIndexCard - State', this.state);

		let userParams = {
			query: this.state.query,
			roles: this.state.filteredRoles,
			status: this.state.filteredAccountStatus,
			page: this.state.currentPage,
			sort: `${this.state.sortColumn},${this.state.sortOrder}`,
			size: this.state.pageLength
		};

		return (
			<div className="UsersIndexCard">
				<div className="card">
					<div className="card-body">
						<div className="row">
							<div className="col-6">
								<h1 className="card-title">
									<div className="UsersTitle">
										{I18n.t('admin.users')}{' '}
										<span>
											{this.state.meta.page ? (
												`(${this.state.meta.page.totalElements.toLocaleString()})`
											) : (
												''
											)}
										</span>
									</div>{' '}
								</h1>
							</div>
							<div className="UsersInviteCard col-6">
								<PopupWithUseClickOutside
									isPopupVisible={this.state.isUserInvitePopupVisible}
									onHidePopup={this.onHideUserInvitePopup}
								>
									<UsersInviteCard
										onHidePopup={this.onHideUserInvitePopup}
										iam_get_user_roles_endpoint={
											this.props.iam_get_user_roles_endpoint
										}
										iam_send_invitations_endpoint={
											this.props.iam_send_invitations_endpoint
										}
										onShowSuccessCardPopup={this.onShowSuccessCardPopup}
										onShowTimeoutCardPopup={this.onShowTimeoutCardPopup}
									/>
								</PopupWithUseClickOutside>
								<PopupWithUseClickOutside
									isPopupVisible={this.state.isSuccessCardPopupVisible}
									onHidePopup={this.onHideSuccessCardPopup}
								>
									<Popup
										title={
											<h1 className="card-title" style={{ color: 'green' }}>
												{I18n.t('success_card_title')}
											</h1>
										}
										body={I18n.t('user_invitations_success_card_body')}
										onHidePopup={this.onHideSuccessCardPopup}
									/>
								</PopupWithUseClickOutside>
								<PopupWithUseClickOutside
									isPopupVisible={this.state.isTimeoutCardPopupVisible}
									onHidePopup={this.onHideTimeoutCardPopup}
								>
									<Popup
										title={
											<h1 className="card-title" style={{ color: 'red' }}>
												{I18n.t('timeout_card_title')}
											</h1>
										}
										body={I18n.t('timeout_card_body')}
										onHidePopup={this.onHideTimeoutCardPopup}
									/>
								</PopupWithUseClickOutside>
								{this.props.permissionsHelper.isOnlyProctor() ? null : (
									<button
										type="button"
										id="new-user"
										className="btn btn-primary"
										onClick={this.onShowUserInvitePopup}
									>
										{I18n.t('users_invite.invite_users_button')}
									</button>
								)}
							</div>
						</div>
						{this.props.permissionsHelper.isOnlyProctor() &&
						this.state.meta &&
						this.state.meta.page &&
						this.state.meta.page.totalElements <= 0 ? (
							<div
								className="jumbotron mt-4 mb-0 text-center"
								style={{ backgroundColor: '#fff' }}
							>
								<div>{'No users found.'}</div>
							</div>
						) : (
							<div>
								<div className="row filter-section">
									<div className="col-md-6">
										<div className="row">
											<div className="col-10 col-md-10 col-lg-10">
												<SearchBar2
													placeholder={I18n.t('search_bar.placeholder')}
													name="tempQuery"
													value={this.state.tempQuery}
													onChange={this.onChange}
													onSubmit={this.onSearch}
												/>
											</div>
											<div className="col-1 col-md-2 col-lg-2">
												{this.state.tempQuery.length > 0 ? (
													<button
														type="button"
														style={{ marginLeft: '-15px' }}
														className="btn btn-primary"
														onClick={this.onClearSearch}
													>
														{I18n.t('admin.clear')}
													</button>
												) : (
													''
												)}
											</div>
										</div>
									</div>
									<div className="col-12 col-md-3 mb-2">
										<Select2DropdownList
											name="filteredRoles"
											placeholder={I18n.t('admin.roles')}
											// data={this.getRolesForSelect2(this.state.meta)}
											endpoint={this.props.iam_get_user_roles_endpoint}
											style={{ width: '100%', display: 'block' }}
											onChange={this.onChange}
										/>
									</div>
									<div className="col-12 col-md-3">
										<Select2DropdownList
											name="filteredAccountStatus"
											dataPlaceholder={I18n.t('admin.account_statuses')}
											data={[
												{
													id: -1,
													text: I18n.t('admin.account_statuses')
												},
												{
													id: 'ACTIVE',
													text: 'Active'
												},
												{
													id: 'EXPIRED',
													text: 'Expired'
												},
												{
													id: 'SUSPENDED',
													text: 'Suspended'
												},
												{
													id: 'PENDING',
													text: 'Pending'
												}
											]}
											style={{ width: '100%', display: 'block' }}
											onChange={this.onChange}
											value={this.state.filteredAccountStatus}
										/>
									</div>
								</div>
								<div className="row">
									<div className="col-12">
										<DataTable2
											// data={this.props.data}
											endpoint={this.props.iam_get_users_endpoint}
											params={userParams}
											sortOrder={this.state.sortOrder}
											sortColumn={this.state.sortColumn}
											columns={[
												{
													displayName: 'Name',
													apiName: 'sortingName',
													colNum: 1,
													colWidth: 35
												},
												{
													displayName: 'Roles',
													apiName: 'roles',
													colNum: 2,
													colWidth: 33,
													isSortable: false
												},
												{
													displayName: 'First Active',
													apiName: 'firstLoginAt',
													colNum: 3,
													colWidth: 17
												},
												{
													displayName: 'Last Active',
													apiName: 'lastLoginAt',
													colNum: 4,
													colWidth: 17
												}
											]}
											rowRenderer={(d) => {
												// console.log('d', d);
												const invitationIssuedDate = new Date(
													d.summary.issuedAt
												);

												return (
													<tr
														key={d.id}
														onClick={() => {
															this.onClickRouteToUserProfilePage(d.id);
														}}
													>
														<td>
															<Cell
																value={this.getName(
																	d.summary.names,
																	d.sortingName
																)}
																tag={
																	d.summary.status.name === 'PENDING' ? (
																		<PendingTag />
																	) : d.summary.status.name === 'EXPIRED' ? (
																		<ExpiredTag />
																	) : d.summary.status.name === 'SUSPENDED' ? (
																		<SuspendedTag />
																	) : (
																		''
																	)
																}
																subtext={
																	d.summary.issuedAt ? (
																		`Sent on ${invitationIssuedDate.toLocaleDateString()}`
																	) : (
																		''
																	)
																}
															/>
														</td>
														<td>
															<Cell
																value={d.summary.roles
																	.map((role) => role.displayAs)
																	.join(', ')}
															/>
														</td>
														<td>
															<Cell
																value={d.summary.firstLoginAt}
																type="date"
															/>
														</td>
														<td>
															<Cell value={d.summary.lastLoginAt} type="date" />
														</td>
													</tr>
												);
											}}
											onChange={this.onChange}
											onChangeSortOrder={this.onChangeSortOrder}
										/>
									</div>
								</div>
								<div className="row table-footer">
									<div className="col-12 col-sm-6">
										<Pagination
											totalRecords={
												this.state.meta.page ? (
													this.state.meta.page.totalElements
												) : (
													0
												)
											}
											pageLength={this.state.pageLength}
											currentPage={this.state.currentPage + 1}
											pageNeighbours={this.state.pageNeighbours}
											onChangeCurrentPage={this.onChangeCurrentPage}
										/>
									</div>
									<div className="col-12 col-sm-6">
										<DataTableDisplayLengthToggle
											totalRecords={
												this.state.meta.page ? (
													this.state.meta.page.totalElements
												) : (
													0
												)
											}
											displayOptions={this.state.displayOptions}
											pageLength={this.state.pageLength}
											onChangePageLength={this.onChangePageLength}
										/>
									</div>
								</div>
							</div>
						)}
					</div>
				</div>
			</div>
		);
	}

	onChange(event) {
		// console.log('event', event);
		const { name, value } = event.target;
		const { state } = this;
		state[name] = value;
		this.setState(state);
	}

	onSearch(event) {
		event.preventDefault();
		// console.log('Query', event.target.value);
		this.setState({ query: this.state.tempQuery, currentPage: 0 });
	}

	onClearSearch(event) {
		event.preventDefault();
		// console.log('Clear Search Query', event.target.value);
		this.setState({ tempQuery: '', query: '', currentPage: 0 });
	}

	onChangeSortOrder(sortColumn, sortOrder) {
		// console.log('onChangeSortOrder', sortColumn, sortOrder);
		if (sortOrder === '' || sortOrder === 'desc') {
			this.setState({
				sortColumn: sortColumn,
				sortOrder: 'asc',
				currentPage: 0
			});
		} else if (sortOrder === 'asc') {
			this.setState({
				sortColumn: sortColumn,
				sortOrder: 'desc',
				currentPage: 0
			});
		}
	}

	onClickRouteToUserProfilePage = (userId) => {
		window.location.href = `/admin/${this.props.public_id}/users/:id`.replace(
			':id',
			userId
		);
	};

	onChangeCurrentPage(currentPage) {
		this.setState({ currentPage: currentPage - 1 });
	}

	onChangePageLength(pageLength) {
		this.setState({ pageLength: pageLength, currentPage: 0 });
	}

	onShowUserInvitePopup = () => {
		this.setState({ isUserInvitePopupVisible: true });
	};

	onHideUserInvitePopup = () => {
		this.setState({ isUserInvitePopupVisible: false });
	};

	onShowSuccessCardPopup = () => {
		this.setState({ isSuccessCardPopupVisible: true });
	};

	onHideSuccessCardPopup = () => {
		this.setState({ isSuccessCardPopupVisible: false });
	};

	onShowTimeoutCardPopup = () => {
		this.setState({ isTimeoutCardPopupVisible: true });
	};

	onHideTimeoutCardPopup = () => {
		this.setState({ isTimeoutCardPopupVisible: false });
	};

	getName(names, defaultName) {
		const emailAddressPrincipal = names.find(
			(obj) => obj.type === 'EMAIL_ADDRESS_PRINCIPAL'
		);
		const emailAddress = names.find((obj) => obj.type === 'EMAIL_ADDRESS');
		const ssoPrincipal = names.find((obj) => obj.type === 'SSO_PRINCIPAL');

		// console.log('emailAddressPrincipal', emailAddressPrincipal);
		// console.log('emailAddress', emailAddress);
		// console.log('ssoPrincipal', ssoPrincipal);

		return emailAddressPrincipal
			? emailAddressPrincipal.values[0]
			: ssoPrincipal
				? ssoPrincipal.values[0]
				: emailAddress ? emailAddress.values[0] : defaultName;
	}

	// getRolesForSelect2(metadata) {
	// 	// console.log('metadata', metadata);
	// 	let roles = [];
	// 	if (metadata && metadata.roles) {
	// 		metadata.roles.map((role) => {
	// 			roles.push({ id: role.name, text: role.displayAs });
	// 		});
	// 	}
	// 	console.log('roles', roles);
	// 	return roles;
	// }
}
